import React, { useState } from 'react'
import './contactFormSection.scss'
import Button from '../../../../components/button/Button'
import emailjs from 'emailjs-com'

const ContactFormSection = () => {
  const [message, setMessage] = useState(false)
  const [error, setError] = useState(false)

  function sendEmail(e) {
    e.preventDefault()

    emailjs.sendForm('service_ji3lq3e', 'template_bj3yktg', e.target, 'user_R7HCclwvKPy5qibmkBZh7')
        .then((result) => {
            result.status === 200 && setMessage(true);
        }, (error) => {
            error && setError(true)
        });
    e.target.reset()
  }

  return (
    <div className="contact__section">
      <div className="contact__section__wrapper">
        <div className="contact__section__wrapper__form">
          <h1 className="contact__section__wrapper__heading primary__heading">Contact our sales team</h1>

          <p className="contact__section__wrapper__paragraph">
            We love to talk. Please contact us with any questions or concerns.
          </p>

          <form action="" onSubmit={sendEmail}>
            <input
              className="contact__section__wrapper__form__input"
              type="text"
              id="full-name"
              name="fullName"
              placeholder="Full Name"
              minLength="2"
              maxLength="50"
              required
            />
            <input
              className="contact__section__wrapper__form__input"
              type="text"
              id="email"
              name="email"
              placeholder="Email Address"
              minLength="2"
              maxLength="50"
              title="Valid email only"
              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
              required
            />
            <input
              className="contact__section__wrapper__form__input"
              type="text"
              id="number"
              name="number"
              placeholder="Contact Number"
              minLength="2"
              maxLength="50"
            />
            <textarea
              className="contact__section__wrapper__form__input"
              rows="4"
              id="message"
              name="message"
              placeholder="Enter your message"
              minLength="2"
              maxLength="256"
              required
            />
            {message && (
              <div className={[error ? 'error_message' : 'success_message', 'message'].join(' ')}>
                {error
                  ? 'There' + ' was an' + ' error submitting your message.'
                  : 'Message recieved. Have a great day!'}
              </div>
            )}
            <Button isSubmit={true} type="primary" text="Send Request" />
          </form>
        </div>
      </div>
    </div>
  )
}

export default ContactFormSection
